const valueRegex = /^[A-Za-z][\w\-.:]*$/;

export { valueRegex as v };
